import type { AuthUser } from '@/api/authUser';

type OnboardingUser =
  | {
      id?: string;
      terms_accepted_at?: string | null;
      profile_completed_at?: string | null;
    }
  | AuthUser
  | null
  | undefined;

/** True only when the API says this account has not accepted Terms yet. */
function needsTermsAcceptance(user: OnboardingUser): boolean {
  if (!user) return false;
  if (user.terms_accepted_at) return false;
  return 'terms_accepted_at' in user && !user.terms_accepted_at;
}

/** True only when the server says this account has not finished the intro page. */
export function needsCompanyProfile(user: OnboardingUser): boolean {
  if (!user) return false;
  return 'profile_completed_at' in user && !user.profile_completed_at;
}

/**
 * Intro for accounts that are new in the database.
 * Existing rows are backfilled, so both timestamps are set and this is false.
 */
export function needsOnboarding(user: OnboardingUser): boolean {
  if (!user) return false;
  return needsTermsAcceptance(user) || needsCompanyProfile(user);
}
